import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-static-notice',
    templateUrl: './static-notice.component.html',
    styleUrls: ['./static-notice.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StaticNoticeComponent {
  @Input() text?: string;
  @Input() texts?: string[];
  @Input() icon: string = 'info';
}
